import React from 'react'
import './Layout.css'
import AvaLAN_Logo from '../../../../src/assets/AvaLAN_Logo.png';
import { Link } from 'react-router-dom';
export const AuthLayout = () => {
    return (
        <>
            <div className="logo-container">
                <Link to=''><img src='img/logoL' className="logo"  width="250" alt="AvaLAN Networks logo" style={{pointerEvents: 'none'}}/></Link>
            </div>
        </>
    )
}
